<template lang="pug">
.container-resize(id="BoundingBox-container")
  .resize.resize-rectangle(
    id="BoundingBox-resizeRectangle",
    ref='resize-rectangle',
    :class='{ visible: selectedLayer }',
    :style='getStyleForResizeHandle("rectangle")',
    draggable,
    @dragstart="dragStartButtonEventHandler('rectangle', $event)",
    @drag="dragButtonEventHandler('rectangle', $event)",
    @dragend="dragEndButtonEventHandler('rectangle', $event)",
  )
  .resize.resize-button.resize-nw(
    ref='resize-nw',
    :class='{ visible: selectedLayer && !dragStartRectangle }',
    :style='getStyleForResizeHandle("nw")'
    draggable,
    @dragstart="dragStartButtonEventHandler('nw', $event)",
    @drag="dragButtonEventHandler('nw', $event)",
    @dragend="dragEndButtonEventHandler('nw', $event)",
  )
  .resize.resize-button.resize-n(
    ref='resize-n',
    :class='{ visible: selectedLayer && !dragStartRectangle }',
    :style='getStyleForResizeHandle("n")',
    draggable,
    @dragstart="dragStartButtonEventHandler('n', $event)",
    @drag="dragButtonEventHandler('n', $event)",
    @dragend="dragEndButtonEventHandler('n', $event)",
  )
  .resize.resize-button.resize-ne(
    ref='resize-ne',
    :class='{ visible: selectedLayer && !dragStartRectangle }',
    :style='getStyleForResizeHandle("ne")',
    draggable,
    @dragstart="dragStartButtonEventHandler('ne', $event)",
    @drag="dragButtonEventHandler('ne', $event)",
    @dragend="dragEndButtonEventHandler('ne', $event)",
  )
  .resize.resize-button.resize-sw(
    ref='resize-sw',
    :class='{ visible: selectedLayer && !dragStartRectangle }',
    :style='getStyleForResizeHandle("sw")',
    draggable,
    @dragstart="dragStartButtonEventHandler('sw', $event)",
    @drag="dragButtonEventHandler('sw', $event)",
    @dragend="dragEndButtonEventHandler('sw', $event)",
  )
  .resize.resize-button.resize-s(
    ref='resize-s',
    :class='{ visible: selectedLayer && !dragStartRectangle }',
    :style='getStyleForResizeHandle("s")',
    draggable,
    @dragstart="dragStartButtonEventHandler('s', $event)",
    @drag="dragButtonEventHandler('s', $event)",
    @dragend="dragEndButtonEventHandler('s', $event)",
  )
  .resize.resize-button.resize-se(
    ref='resize-se',
    :class='{ visible: selectedLayer && !dragStartRectangle }',
    :style='getStyleForResizeHandle("se")',
    draggable,
    @dragstart="dragStartButtonEventHandler('se', $event)",
    @drag="dragButtonEventHandler('se', $event)",
    @dragend="dragEndButtonEventHandler('se', $event)",
  )
  .resize.resize-button.resize-e(
    ref='resize-e',
    :class='{ visible: selectedLayer && !dragStartRectangle }',
    :style='getStyleForResizeHandle("e")',
    draggable,
    @dragstart="dragStartButtonEventHandler('e', $event)",
    @drag="dragButtonEventHandler('e', $event)",
    @dragend="dragEndButtonEventHandler('e', $event)",
  )
  .resize.resize-button.resize-w(
    ref='resize-w',
    :class='{ visible: selectedLayer && !dragStartRectangle }',
    :style='getStyleForResizeHandle("w")',
    draggable,
    @dragstart="dragStartButtonEventHandler('w', $event)",
    @drag="dragButtonEventHandler('w', $event)",
    @dragend="dragEndButtonEventHandler('w', $event)",
  )

  //- Tried hard for-in, did not work, seems vue does not support dynamic class names  :(
  //- .resize.resize-button(
  //-   v-for='direction in ["nw", "n", "ne", "sw", "s", "se", "e", "w"]',
  //-   :ref='`resize-${direction}`',
  //-   :class='{ visible: selectedLayer,  'resize-' + direction: true }',
  //-   :style='getStyleForResizeHandle(direction)'
  //- )
</template>

<script>
export default {
  props: ['selectedLayer'],
  mixins: [],
  components: {
  },
  created () {
    // Firefox hack (clientX/Y in $event are always 0, since A.D. 2004... they refuse to fix)
    const that = this
    document.addEventListener('dragover', function ($event) {
      that.dragEventCoordinates = {
        clientX: $event.clientX,
        clientY: $event.clientY
      }
    })
  },
  updated () {
  },
  watch: {
  },
  data () {
    return {
      errors: [],
      resizeboxes: {
        sizePx: 6,
        rectangle: { top: 0, left: 0, width: 0, height: 0 },
        nw: { top: 0, left: 0, width: 6, height: 6 },
        n: { top: 0, left: 0, width: 6, height: 6 },
        ne: { top: 0, left: 0, width: 6, height: 6 },
        sw: { top: 0, left: 0, width: 6, height: 6 },
        s: { top: 0, left: 0, width: 6, height: 6 },
        se: { top: 0, left: 0, width: 6, height: 6 },
        e: { top: 0, left: 0, width: 6, height: 6 },
        w: { top: 0, left: 0, width: 6, height: 6 }
      },
      dragStartPosition: {
        clientX: undefined,
        clientY: undefined
      },
      dragStartRectangle: undefined,
      dragEventCoordinates: { clientX: undefined, clientY: undefined }
    }
  },
  methods: {
    dragStartButtonEventHandler (button, $event) {
      this.dragStartPosition.clientX = $event.clientX
      this.dragStartPosition.clientY = $event.clientY
      this.dragStartRectangle = JSON.parse(JSON.stringify(this.resizeboxes.rectangle))
    },
    dragButtonEventHandler (button, $event) {
      if (this.dragEventCoordinates.clientX < 10 || this.dragEventCoordinates.clientY < 10) return
      switch (button) {
        case 'nw':
          this.resizeboxes.rectangle.left = this.dragStartRectangle.left + this.dragEventCoordinates.clientX - this.dragStartPosition.clientX
          this.resizeboxes.rectangle.top = this.dragStartRectangle.top + this.dragEventCoordinates.clientY - this.dragStartPosition.clientY
          this.resizeboxes.rectangle.width = this.dragStartRectangle.width - (this.dragEventCoordinates.clientX - this.dragStartPosition.clientX)
          this.resizeboxes.rectangle.height = this.dragStartRectangle.height - (this.dragEventCoordinates.clientY - this.dragStartPosition.clientY)
          break
        case 'sw':
          this.resizeboxes.rectangle.left = this.dragStartRectangle.left + this.dragEventCoordinates.clientX - this.dragStartPosition.clientX
          this.resizeboxes.rectangle.width = this.dragStartRectangle.width - (this.dragEventCoordinates.clientX - this.dragStartPosition.clientX)
          this.resizeboxes.rectangle.height = this.dragStartRectangle.height + (this.dragEventCoordinates.clientY - this.dragStartPosition.clientY)
          break
        case 'se':
          this.resizeboxes.rectangle.width = this.dragStartRectangle.width + this.dragEventCoordinates.clientX - this.dragStartPosition.clientX
          this.resizeboxes.rectangle.height = this.dragStartRectangle.height + this.dragEventCoordinates.clientY - this.dragStartPosition.clientY
          break
        case 'ne':
          this.resizeboxes.rectangle.top = this.dragStartRectangle.top + this.dragEventCoordinates.clientY - this.dragStartPosition.clientY
          this.resizeboxes.rectangle.width = this.dragStartRectangle.width + (this.dragEventCoordinates.clientX - this.dragStartPosition.clientX)
          this.resizeboxes.rectangle.height = this.dragStartRectangle.height - (this.dragEventCoordinates.clientY - this.dragStartPosition.clientY)
          break
        case 'n':
          this.resizeboxes.rectangle.top = this.dragStartRectangle.top + this.dragEventCoordinates.clientY - this.dragStartPosition.clientY
          this.resizeboxes.rectangle.height = this.dragStartRectangle.height - (this.dragEventCoordinates.clientY - this.dragStartPosition.clientY)
          break
        case 's':
          this.resizeboxes.rectangle.height = this.dragStartRectangle.height + (this.dragEventCoordinates.clientY - this.dragStartPosition.clientY)
          break
        case 'w':
          this.resizeboxes.rectangle.left = this.dragStartRectangle.left + this.dragEventCoordinates.clientX - this.dragStartPosition.clientX
          this.resizeboxes.rectangle.width = this.dragStartRectangle.width - (this.dragEventCoordinates.clientX - this.dragStartPosition.clientX)
          break
        case 'e':
          this.resizeboxes.rectangle.width = this.dragStartRectangle.width + (this.dragEventCoordinates.clientX - this.dragStartPosition.clientX)
          break
        case 'rectangle':
          break
        default:
          break
      }
      if (this.resizeboxes.rectangle.width < 0) this.resizeboxes.rectangle.width = 0
      if (this.resizeboxes.rectangle.height < 0) this.resizeboxes.rectangle.height = 0
      this.$emit('boxResizing', { id: this.selectedLayer.id, box: this.resizeboxes.rectangle })
    },
    dragEndButtonEventHandler (button, $event) {
      if (button === 'rectangle') {
        this.resizeboxes.rectangle.top = this.dragStartRectangle.top + this.dragEventCoordinates.clientY - this.dragStartPosition.clientY
        this.resizeboxes.rectangle.left = this.dragStartRectangle.left + this.dragEventCoordinates.clientX - this.dragStartPosition.clientX
      }
      this.__calculateResizeBox({
        offsetTop: this.resizeboxes.rectangle.top,
        offsetLeft: this.resizeboxes.rectangle.left,
        offsetWidth: this.resizeboxes.rectangle.width,
        offsetHeight: this.resizeboxes.rectangle.height
      })
      this.dragStartPosition = {
        clientX: undefined,
        clientY: undefined
      }
      this.dragStartRectangle = undefined
      this.$emit('boxResized', { id: this.selectedLayer.id, box: this.resizeboxes.rectangle, resizeDirection: button })
    },
    getStyleForResizeHandle (element) {
      return `top:${this.resizeboxes[element].top}px; left:${this.resizeboxes[element].left}px; width:${this.resizeboxes[element].width}px; height:${this.resizeboxes[element].height}px`
    },
    __calculateResizeBox (zone, adjustment = 0) {
      if (!this.selectedLayer) return
      // const coords = zone.getBoundingClientRect()
      this.resizeboxes.rectangle.top = zone.offsetTop - adjustment
      this.resizeboxes.rectangle.left = zone.offsetLeft
      this.resizeboxes.rectangle.width = zone.offsetWidth
      this.resizeboxes.rectangle.height = zone.offsetHeight

      this.resizeboxes.nw.top = zone.offsetTop - 3 - adjustment
      this.resizeboxes.nw.left = zone.offsetLeft - 3

      this.resizeboxes.n.top = zone.offsetTop - 3 - adjustment
      this.resizeboxes.n.left = zone.offsetLeft + (zone.offsetWidth / 2) - 3

      this.resizeboxes.ne.top = zone.offsetTop - 3 - adjustment
      this.resizeboxes.ne.left = zone.offsetLeft + zone.offsetWidth - 3

      this.resizeboxes.sw.top = zone.offsetTop + zone.offsetHeight - 3 - adjustment
      this.resizeboxes.sw.left = zone.offsetLeft - 3

      this.resizeboxes.s.top = zone.offsetTop + zone.offsetHeight - 3 - adjustment
      this.resizeboxes.s.left = zone.offsetLeft + (zone.offsetWidth / 2) - 3

      this.resizeboxes.se.top = zone.offsetTop + zone.offsetHeight - 3 - adjustment
      this.resizeboxes.se.left = zone.offsetLeft + zone.offsetWidth - 3

      this.resizeboxes.w.left = zone.offsetLeft - 3
      this.resizeboxes.w.top = zone.offsetTop + (zone.offsetHeight / 2) - 3 - adjustment

      this.resizeboxes.e.left = zone.offsetLeft + zone.offsetWidth - 3
      this.resizeboxes.e.top = zone.offsetTop + (zone.offsetHeight / 2) - 3 - adjustment
    }
  },
  computed: {
  }
}
</script>
<style lang="scss">
@import "../../../../theme-m4b/src/common/var.scss";
.resizeboxes-debug {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
}
.container-resize {
  position: relative;
  .resize {
    &.resize-rectangle {
      cursor: move;
    }
    position: absolute;
    box-shadow:inset 0px 0px 0px 1px $--color-warning;
    width: 6px;
    height: 6px;
    z-index: 20;
    display: none;
    &.resize-button {
      background-color: $--color-warning;
      &.resize-n {
        cursor: n-resize;
      }
      &.resize-s {
        cursor: s-resize;
      }
      &.resize-w {
        cursor: w-resize;
      }
      &.resize-e {
        cursor: e-resize;
      }
      &.resize-nw {
        cursor: nw-resize;
      }
      &.resize-ne {
        cursor: ne-resize;
      }
      &.resize-sw {
        cursor: sw-resize;
      }
      &.resize-se {
        cursor: se-resize;
      }
    }
    &.visible {
      display: block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Medium/LayoutEditor/BoundingBox.vue